/**
 * OTRIX Play — gasto calórico por ejercicio con base MET (Compendium of Physical Activities,
 * valores redondeados para fuerza/calistenia/cardio moderados). Reemplaza el plano
 * "7 kcal/min para todo": ahora una sentadilla pesa más que un curl y el descanso casi nada.
 *
 * kcal/min = MET × 3.5 × peso(kg) / 200. El backend NO calcula calorías (solo persiste
 * `estimated_calories`), así que esta tabla vive SOLO aquí; si algún día se calcula en el
 * backend, espejar estos valores.
 */

export const DEFAULT_WEIGHT_KG = 75;

// MET de TRABAJO por tipo de ejecución.
const MET_BY_TYPE = {
  COMPOUND: 6,
  CALISTHENICS: 5,
  ISOLATION: 3.5
};

// Compuestos de pierna (sentadilla, peso muerto, zancada): más masa muscular involucrada.
const MET_LEG_COMPOUND = 7;
const MET_CARDIO = 8;
const MET_DEFAULT = 5;

// Descanso entre series/ejercicios: de pie, recuperándose.
export const MET_REST = 1.8;

/** MET de trabajo de un ejercicio según su tipo y grupo muscular. */
export const metFor = (exercise) => {
  const muscle = exercise?.muscle_group || null;
  const type = exercise?.exercise_type || null;

  if (muscle === 'CARDIO') return MET_CARDIO;
  if (type === 'COMPOUND' && (muscle === 'LEGS' || muscle === 'QUADS' || muscle === 'GLUTES' || muscle === 'HAMSTRINGS')) {
    return MET_LEG_COMPOUND;
  }
  return MET_BY_TYPE[type] || MET_DEFAULT;
};

/** Calorías de un tramo de `seconds` a un MET dado. */
export const kcalFor = (seconds, met, weightKg = DEFAULT_WEIGHT_KG) => {
  const minutes = Math.max(0, seconds) / 60;
  const kg = Number(weightKg) > 0 ? Number(weightKg) : DEFAULT_WEIGHT_KG;
  return (minutes * (met * 3.5 * kg)) / 200;
};
